export default {"src":"/_next/static/media/couch_24.a5cabc56.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};